const DEFAULT_SECTION = "order";

export const ORDER_FIELDS_CONFIG_TYPE = {
  ORDER_CARD: "ORDER_CARD",
  ORDER_HOVER_CARD: "ORDER_HOVER_CARD",
};

export const getGroupedFieldsConfig = (config) => {
  if (!config) {
    return [];
  }

  const groups = {};

  config.forEach((field) => {
    const [groupKey] = field.fieldKey.includes(".")
      ? field.fieldKey.split(".")
      : [DEFAULT_SECTION];

    if (!groups[groupKey]) {
      groups[groupKey] = [];
    }

    groups[groupKey].push(field);
  });

  return Object.entries(groups).map(([section, fields]) => ({
    section,
    fields,
  }));
};

export const getMaxDisplayOrder = (config) => {
  if (!config) {
    return 0;
  }

  return config.reduce(
    (max, field) => Math.max(max, field.displayOrder || 0),
    0
  );
};
